/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import type { ReactEventHandler } from 'react';

import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

/**
 * Shared thumbnail image component for search result media previews.
 */
const THUMBNAIL_WIDTH = 204;
const THUMBNAIL_HEIGHT = 132;

const thumbnailImageStyles = css({
	objectFit: 'cover',
	objectPosition: 'center',
	width: '204px',
	height: '132px',
	borderRadius: token('radius.medium'),
	borderWidth: token('border.width.selected'),
	borderStyle: 'solid',
	borderColor: token('color.text.disabled', '#091E4224'),
});

interface ThumbnailImageProps {
	src: string;
	alt?: string;
	onError?: ReactEventHandler<HTMLImageElement>;
}

/**
 * A shared image element for search result thumbnails.
 * Encapsulates the standard thumbnail dimensions (204px x 132px) and styles
 * so that image and video search result thumbnails stay in sync.
 */
export const ThumbnailImage = ({ src, alt, onError }: ThumbnailImageProps) => (
	<img
		css={thumbnailImageStyles}
		src={src}
		alt={alt}
		onError={onError}
		width={THUMBNAIL_WIDTH}
		height={THUMBNAIL_HEIGHT}
	/>
);
